import SEO from "../ui/SEO.jsx";

export default function Sobre() {
  return (
    <div className="max-w-2xl">
      <SEO
        title="Sobre"
        description="Sobre o projeto Aqui no Japão: ferramentas honestas para brasileiros no Japão, feitas por quem vive aqui."
        path="/sobre"
      />
      
      <div className="text-[11px] tracking-[0.18em] uppercase text-accent mb-4 font-semibold">
        Sobre
      </div>
      <h1 className="font-serif font-medium text-4xl md:text-5xl leading-tight tracking-tight mb-6">
        Por que esse site existe
      </h1>

      <div className="space-y-5 text-[17px] leading-[1.7] text-ink">
        <p>
          Toda decisão de quem vive no Japão como dekassegui passa por uma
          conta na cabeça: <em className="font-serif italic">quanto eu realmente ganho?</em>{" "}
          <em className="font-serif italic">vale a pena ficar mais um ano?</em>{" "}
          <em className="font-serif italic">se eu voltar, o que sobra?</em>
        </p>
        <p>
          A internet em português sobre essas perguntas é confusa, defasada,
          ou foi feita para vender alguma coisa. Os grupos de Facebook ajudam,
          mas cada caso vira boato. Os contadores cobram caro para responder
          o que poderia ser uma conta de planilha.
        </p>
        <p>
          Este site é a planilha. Ferramentas práticas, com fórmulas abertas,
          baseadas em tabelas oficiais. Quando a lei muda, a calculadora muda.
          Quando a gente não sabe alguma coisa, escreve <em className="font-serif italic">não sei, consulta um contador</em>.
        </p>

        <h2 className="font-serif font-medium text-2xl mt-10 mb-3">
          Como ele se sustenta
        </h2>
        <p>
          Com publicidade discreta e links de afiliado em serviços que a gente
          usaria de qualquer jeito (remessas, principalmente). Nada de pop-up,
          nada de email de venda, nada de &ldquo;curso de japonês&rdquo;.
        </p>

        <h2 className="font-serif font-medium text-2xl mt-10 mb-3">
          O que esse site <em className="font-serif italic">não</em> é
        </h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Não é despachante. Não fazemos visto, não fazemos imposto.</li>
          <li>Não somos contadores nem advogados. Tudo aqui é educacional.</li>
          <li>Não compartilhamos seus dados — nem temos onde compartilhar.</li>
          <li>
            Não somos representantes oficiais de nenhum órgão japonês ou
            brasileiro.
          </li>
        </ul>

        <h2 className="font-serif font-medium text-2xl mt-10 mb-3">
          Quem está por trás
        </h2>
        <p>
          Um brasileiro vivendo em Maizuru (Kyoto), trabalhando em uma fábrica
          como contratado, estudando japonês, e fazendo as mesmas contas que
          você faz no fim do mês. Este site começou como uma planilha pessoal
          que virou ferramenta porque os amigos pediam.
        </p>
        <p>
          Sugestões, correções, ou só dizer oi:{" "}
          <a
            href="mailto:hello@aquinojapao.com"
            className="text-accent underline underline-offset-2"
          >
            hello@aquinojapao.com
          </a>
        </p>
      </div>
    </div>
  );
}
